
import { Component, Mixins, Watch } from 'vue-property-decorator';
import ShipmentDetails from '@/features/shipment-history/components/details/shipmentDetails/ShipmentDetails.vue';
import TrackingDetails from '@/features/shipment-history/components/details/trackingDetails/TrackingDetails.vue';
// import Comments from '@/features/shipment-history/components/details/comments/Comments.vue';
import SchedulePickupFlow from '@/features/schedule-pickup/components/SchedulePickupFlow.vue';
import { HistoryItemType, TrackingDetailsType } from '@/features/shipment-history/types';
import HistoryNoResults from '@/features/shipment-history/components/HistoryNoResults.vue';
import { getShipment, getTrackingDetails } from '@/features/shipment-history/services/shipment-history.services';
import { showErrorAlertDialog } from '@/features/common/helpers';
import { TabItem } from '@/features/common/components/BaseTabs.vue';
import { EncodedMapImages, getShipmentMaps } from '@/features/shipment-history/helpers';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { SchedulePickupMixin } from '@/features/schedule-pickup/components/mixins';

@Component({
  components: {
    ShipmentDetails,
    TrackingDetails,
    HistoryNoResults,
    SchedulePickupFlow,
    // Comments,
  },
})
export default class HistoryDetails extends Mixins(ResponsivenessMixin, SchedulePickupMixin) {
  private shipment: HistoryItemType | null = null;

  private trackingDetails: TrackingDetailsType | null = null;

  private isLoading = false;

  private isTrackingLoading = false;

  private tabs = [
    {
      name: 'details',
      title: this.$t('history.tabNames.details') as string,
    },
    {
      name: 'tracking',
      title: this.$t('history.tabNames.tracking') as string,
    },
    // {
    //   name: 'comments',
    //   title: this.$t('history.tabNames.comments') as string,
    // },
  ]

  private activeTabName = 'details';

  private encodedMapImages: EncodedMapImages = {
    from: '',
    to: '',
  }

  get trackingNumber(): string {
    return this.$route.query.id as string;
  }

  get carrierTrackingNumber(): string {
    return this.$route.query.trackingNumber as string;
  }

  get isInitialDataLoaded(): number {
    return this.$store.getters.getIsInitialDataLoaded;
  }

  get loading(): boolean {
    return this.$store.state.loading;
  }

  @Watch('isInitialDataLoaded', { immediate: true })
  private async initFetch(newVal): Promise<void> {
    this.isLoading = true;

    if (!this.trackingNumber || !newVal) {
      this.isLoading = false;
      return;
    }

    this.shipment = await getShipment(this.trackingNumber);

    if (!this.shipment) {
      showErrorAlertDialog();
      this.isLoading = false;
      return;
    }

    this.fetchTrackingDetails();

    await this.fetchShipmentLocationMeta();

    this.isLoading = false;
  }

  private async fetchTrackingDetails() {
    this.isTrackingLoading = true;

    this.trackingDetails = await getTrackingDetails(
      this.trackingNumber,
      this.carrierTrackingNumber || this.shipment?.packages[0].carrierTrackingNumber || '',
    );

    if (!this.shipment || !this.trackingDetails) {
      showErrorAlertDialog();
    }

    this.isTrackingLoading = false;
  }

  private async fetchShipmentLocationMeta() {
    const { fromAddress, toAddress } = this.shipment as HistoryItemType;

    const { fromMap, toMap } = await getShipmentMaps(fromAddress, toAddress);

    this.encodedMapImages.from = fromMap;
    this.encodedMapImages.to = toMap;
  }

  private changeTab({ name }: TabItem): void {
    this.activeTabName = name as string;
  }

  private isActiveTab(tabName: string): boolean {
    return this.activeTabName === tabName;
  }
}
